// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'returnHostname',
    standalone: false,
})
export class ReturnHostnamePipe implements PipeTransform {
    transform (url: string): string {
        if (!url) {
            return '';
        }
        const match = url.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
        return match ? match[1] : '';
    }
}
